import React from "react";
import PropTypes from "prop-types";
import validate from "validate.js";
import jQuery from "jquery";
import "select2/dist/css/select2.min.css";

global.jQuery = jQuery;
global.jquery = jQuery;
global.$ = jQuery;
require("select2/dist/js/select2.min.js");

/**
 * Componente que corresponde a un input básico.
 *
 * @param {*} props
 * @param {string} [styleName] class adicional del select. Default undefined.
 * @param {function}[handleChange] handler del evento change. Default `undefined`.
 */

export default class Select extends React.Component {
  /**
   *
   * @constructor
   */
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.renderFeedback = this.renderFeedback.bind(this);
    this.getClassName = this.getClassName.bind(this);
    this.state = {};
    this.state.value = props.value ? props.value : "";

    let rnd = Math.round(Math.random() * 10000);
    this._id = "form-select-" + rnd + "-" + new Date().getTime();
  }

  /**
   * Se encarga de inizializar el plugin select2 de jquery
   * y hacer bind del evento change.
   */
  initSelect2() {
    if (typeof this.$el === "undefined") {
      return;
    }
    //this.$el = jQuery(this.el);
    this.$el
      .select2({
        tags: this.props.tags,
        placeholder: this.props.placeholder,
        disabled: this.props.disabled
      })
      .on("select2:select", event => {
        this.handleChange(event);
      })
      .on("select2:close", event => {
        
        let feedback = this.validate(this.props.value);
        this.setState({
          feedback: feedback
        });
      })
      .on("validate", event => {
        let feedback = this.validate(this.props.value);
        this.setState({
          feedback: feedback
        });
      });
  }

  /**
   * Cuando el componente se monta se setea el valor.
   */
  componentDidMount() {
    this.initSelect2();
  }

  /**
   * Handler del evento change del input.
   * @param {*} event
   */
  handleChange(event) {
    const target = event.params.data;
    const value = target.id;
    let feedback = null;

    feedback = this.validate(value);
    //se seta el valor del input.
    this.setState({
      value: value,
      feedback: feedback
    });
    // si existe la función handler de, se dispara la invocación.
    if (typeof this.props.onChange !== "undefined") {
      this.props.onChange(value, event);
    }
  }

  /**
   * Se encarga d evalidar el valor del select
   * @param {*} value
   */
  validate(value) {
    let feedback = null;
    if (this.props.validations) {
      let d = { val: value };
      let constraints = { val: this.props.validations };
      let result = validate(d, constraints);
      feedback = result ? result.val[0].replace("Val ", "") : undefined;
    }
    return feedback;
  }

  /**
   * Se encarga de renderizar el feedback de validación.
   */
  renderFeedback() {
    const hasFeedback =
      this.state.feedback && this.state.feedback.length > 0 ? true : false;
    return (
      <React.Fragment>
        {hasFeedback && <p className="help is-danger">{this.state.feedback}</p>}
        {!hasFeedback && <p className="help">{this.props.help}</p>}
      </React.Fragment>
    );
  }

  /**
   * Si el input es obligatorio retorna true, en caso contrario retorna false.
   */
  isRequired() {
    return this.props.validations && this.props.validations.presence;
  }
  /**
   * Se encarga de recurmerar el classname teniendo en cuenta si el input
   * requiere o no validación.
   */
  getClassName() {
    let clazz = this.props.styleName;
    if (this.isRequired() && this.state.feedback) {
      clazz += " is-danger";
    } else if (this.isRequired) {
      clazz += " is-success";
    }
    return clazz;
  }

  render() {
    return (
      <div className="field">
        <label className="label">{this.props.label}</label>
        <div className="control has-icons-right">
          <div className="select is-fullwidth">
            <select
              style={{ display: "none" }}
              id={this._id}
              ref={el => (this.$el = jQuery(el))}
              name={this.props.name}
              className={this.getClassName()}
              value={this.props.value}
              required={this.isRequired()}
              onChange={this.handleChange}
              data-id={this.props["data-id"]}
            >
              <option />
              {this.props.children}
            </select>
          </div>
          {this.isRequired() && (
            <span className="icon is-right">
              <i className="fas fa-asterisk" />
            </span>
          )}
          {this.renderFeedback()}
        </div>
      </div>
    );
  }
}

/**
 * @param {*} props
 * @param {object} name nombre del input
 * @param {object} [styleName] class adicional del input. Default undefined.
 * @param {object} [placeholder] placeholder del input. Default undefined.
 * @param {object} [type] tipo de input. Default `checkbox`.
 * @param {function}[handleChange] handler del evento change. Default `undefined`.
 */
Select.propTypes = {
  name: PropTypes.string,
  styleName: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  tags: PropTypes.bool.isRequired,
  validations: PropTypes.object
};

Select.defaultProps = {
  styleName: "",
  value: "",
  tags: false
};